import Form from "./Form";
import { getJobFields } from "../utils";
import { useDataContext } from "../contexts";

export default function JobEdit({ callback, id }) {
  const { memberUsers, getJobById } = useDataContext();

  const job = getJobById(id);

  if (!job) {
    return "Job not found";
  }

  const jobFields = getJobFields(memberUsers);

  return (
    <Form
      path="jobs"
      method="PATCH"
      id={job.id}
      submitCallback={callback}
      initialValues={job}
      fields={jobFields}
    />
  );
}
